import destroyAdv from "../utils/destroyAdv";

export default function () {
    window.loadingMedia = undefined;
    destroyAdv([
        'adpartner-media-95',
        'adpartner-media-3913',
        'adpartner_95',
        'adpartner_3913',
        'catfish-desktop-',
        'desktop-catfish-close-button',
        'adpartner-jsunit-'
    ])
}